import styled from "styled-components";
import {withStyles, Tooltip} from "@material-ui/core";

export const Container = styled.div`
    position: relative;
    display: inline-block;
`;

export const NewBadge = styled.span`
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 1;
    background: #FFB020;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.6rem;
    font-weight: bold;
    text-transform: uppercase;
    padding: 2px 8px;
    border-radius: 10px;
`;

// Tooltip rico e escuro do botão (conforme o design): cabeçalho com ícone + título
// e um parágrafo de descrição.
export const RichTooltip = withStyles({
    tooltip: {
        backgroundColor: "#33475B",
        color: "#E8EEF5",
        maxWidth: 300,
        padding: "16px 18px",
        borderRadius: 12,
        fontFamily: "Mulish",
    },
    arrow: {
        color: "#33475B",
    },
})(Tooltip);

export const TooltipHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 8px;
    color: #7FB0FF;
    font-weight: 800;
    font-size: 0.82rem;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    svg { font-size: 0.95rem; }
`;

export const TooltipText = styled.p`
    margin: 0;
    color: #E8EEF5;
    font-size: 0.85rem;
    line-height: 1.5;
`;
